import React, { Component } from "react";
import { Container } from "semantic-ui-react";

class Recommendations extends Component {

	render () {

		return (

			<Container>
				<h2>Recommendations</h2>
				<blockquote>
					<p>Jacob Lamont is a talented individual with a terrific attitude. He always came to work with a smile and a desire to serve his employer and peers. Jacob was our "go to guy" for anything new or out of the box for our programmers/developers. If he didn't have the answer, he loved doing the research and finding out how to do something no one on our team had done previously. I'm happy to give my recommendation on his behalf.</p>
					<footer>
						<cite>– Jared Vallorani - CEO, Liberty Alliance</cite>
					</footer>
				</blockquote>
				<blockquote>
					<p>Jacob proved to be a great collaborator on all web projects we worked on together. He's a professional; knows his way with dev tools, is focused on goals and keeps track of the details. I highly recommend him for programming and development. You cannot find a more dedicated coder.</p>
					<footer>
						<cite>– Joseph Darnell - Video Producer at vLink Solutions</cite>
					</footer>
				</blockquote>
				<blockquote>
					<p>Out of the developers that I've worked with, Jacob displayed the most conscientiousness, initiative, self-direction, and tech savvy of any of them. He routinely drove innovation at Quietyme and was the primary reason we moved our website to the most modern of one-page app technologies with an API running on the backend. He demonstrated excellence in every language I threw at him. He also thoroughly enjoys what he does and was a joy to work with in every way. Anyone who does not take a serious look at hiring him for their web-based projects is foolish to overlook this rare combination of talent and character.</p>
					<footer>
						<cite>– Jonathan Narwold - CTO at Quietyme</cite>
					</footer>
				</blockquote>
			</Container>

		);

	}

}

export default Recommendations;



/** WEBPACK FOOTER **
 ** ./src/modules/Recommendations.js
 **/